{
    "Timezone_Title_Change": "Cambia fuso orario utente",
    "Timezone_Title_Update": "Aggiorna fuso orario utente",
    "Timezone_Dropdown_Title": "Fuso orario",
    "Timezone_Tab_General": "Generale",
    "Timeline_Prompt_Change": "Modifica",
    "Timeline_Prompt_Cancel": "Cancellare",
    "Timeline_Prompt_Change_Message": "Abbiamo rilevato una modifica al fuso orario del tuo utente \n \n In origine era **{}** \n \n Desideri modificare il tuo fuso orario locale in **{}**",
    "Timeline_Prompt_First_Time_Message": "Il fuso orario attuale per i tuoi report è impostato su **{}** \n \n Desideri aggiornare i tuoi report al fuso orario locale **{}**",
    "NAME": "TimezoneModal"
}